import { ChangeDetectionStrategy, Component, OnDestroy, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { AccountAppCommand, Customer } from "@fabric-types/app-account";
import { Store } from "@ngrx/store";
import { CAFAuthenticatorService } from "@obg/mat.ui.common";
import { CORE_ROUTE } from "@obg/ngx.core";
import { FeatureFlagService } from "@obg/ngx.global";
import { DocumentRef } from "@obg/ngx.global.evo";
import { RouteAction, RouterState } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-m-caf-doc-authenticator",
	styleUrls: ["./caf-doc-authenticator.container.scss"],
	templateUrl: "./caf-doc-authenticator.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CafDocAuthenticatorContainer implements OnDestroy {
	showMobileQr?: boolean;
	isLatestDocSdkEnabled?: boolean;
	isCafAuthenticating = false;
	isCafAuthenticated = false;

	constructor(
		private featureFlagService: FeatureFlagService,
		private store: Store<RouterState>,
		private matDialog: MatDialog,
		private cafService: CAFAuthenticatorService,
		private documentRef: DocumentRef
	) {
		this.showMobileQr = this.featureFlagService.get("show_mobile_flow_qr")?.enabled;
		this.isLatestDocSdkEnabled = this.featureFlagService.get("pax_document_detector_sdk_6")?.enabled;
		this.documentRef.obgEventBus.listen(AccountAppCommand.BrazilCafDocumentUploadSuccessful, () => {
			this.closeDialog();
		});

		this.documentRef.obgEventBus?.dispatch(AccountAppCommand.GetCustomer, {
			onSuccess: async (customer: Customer) => {
				this.documentRef.obgEventBus?.dispatch(AccountAppCommand.UpdateRegistrationState, {
					cpf: customer.profile.personalCode?.toString(),
					dob: customer.profile.dateOfBirth,
				});
			},
		});
	}

	cafAuthentication$(): Observable<boolean> {
		if (this.isCafAuthenticated) {
			return of(true);
		}

		if (this.isCafAuthenticating) {
			return of(false);
		}

		return this.cafService.openCafAuthenticator$().pipe(
			map((authToken) => {
				this.isCafAuthenticating = true;
				if (authToken) {
					this.isCafAuthenticated = true;
					return true;
				}

				this.closeDialog();
				return false;
			})
		);
	}

	ngOnDestroy(): void {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
	}

	private closeDialog() {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
		this.matDialog.openDialogs
			.find((dialog) => dialog.id === CORE_ROUTE.responsibleGaming.documentVerification)
			?.close();
	}
}
